type JSONValue = string | number | boolean | null | JSONObject | JSONArray
interface JSONObject {
  [key: string]: JSONValue
}
interface JSONArray extends Array<JSONValue> {}

export const findKey = (objeto: JSONValue, prop: string): JSONValue | undefined => {
  if (typeof objeto !== 'object' || objeto === null) {
    throw new Error('El primer parámetro debe ser un objeto JSON')
  }

  if (Array.isArray(objeto)) {
    for (let i = 0; i < objeto.length; i++) {
      let result = findKey(objeto[i], prop)
      if (result !== undefined) {
        return result
      }
    }
  } else {
    for (let key in objeto) {
      if (objeto.hasOwnProperty(key)) {
        let value = objeto[key]
        if (key === prop) {
          return value
        } else if (typeof value === 'object') {
          let result = findKey(value, prop)
          if (result !== undefined) {
            return result
          }
        }
      }
    }
  }

  return undefined
}
